export enum AuthRoute {
  Login = '',
  TwoFASetup = '2fa-setup',
  TwoFA = '2fa',
  ResetPassword = 'reset-password',
  ConfirmResetPassword = 'confirm-reset-password',
}
